import { render, staticRenderFns } from "./SortFormat.vue?vue&type=template&id=a2f10a04&lang=pug"
import script from "./SortFormat.vue?vue&type=script&lang=js"
export * from "./SortFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports